<script>
  import ProductImage from '../../components/ProductImage.svelte';
  import Carousel from 'svelte-carousel';

  export let carouselImages;
  export let handleImageClick;
  export let showThumbnails = true;

  let carousel;

  function handleThumbnailClick(index) {
    carousel.goTo(index);
  }
</script>

{#if process.browser && carouselImages.length}
  <Carousel
    bind:this={carousel}
    infinite={true}
    autoplay={true}
    autoplayDuration={3000}
    dots={true}
    arrows={false}
    swiping={true}
    pauseOnFocus={true}
  >
    {#each carouselImages as image}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="image-container" on:click={handleImageClick}>
        <ProductImage src={image} height={'100%'} width={'auto'} />
      </div>
    {/each}
  </Carousel>
  {#if showThumbnails}
    <div class="thumbnail-container">
      {#each carouselImages as image, index}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="thumbnail" on:click={() => handleThumbnailClick(index)}>
          <ProductImage src={image} height={'100px'} width={'auto'} />
        </div>
      {/each}
    </div>
  {/if}
{/if}

<style>
  .image-container {
    display: flex;
    justify-content: center;
  }

  .thumbnail-container {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  .thumbnail {
    margin: 0 5px;
  }
</style>
